import React from "react";
import { TitleText } from "../../ui/Text";
import { TaskItem } from "./TaskItem";
import styled from "styled-components";
import { get } from "../../utils/get";
import moment from "moment";

interface IProps {
  backgroundColor?: string;
  data?: any;
  
}
export const Tasks = ({ backgroundColor, data }: IProps) => {
  return (
    <TaskContainer>
      <TitleText
      style={{
        fontSize: 11,
      }}>{moment(get(data, "due_date", "")).format("MMM Do h a")}</TitleText>
      <TaskVerticalLine>
        <VerticalLine />
        <TaskIndicatorContainer>
          <TaskIndicator />
        </TaskIndicatorContainer>
        <VerticalLine />
      </TaskVerticalLine>
      <TaskItem backgroundColor={backgroundColor} data={data} />
    </TaskContainer>
  );
};

const TaskContainer = styled.div`
  display: grid;
  grid-template-columns: 3em 1em auto;
  grid-column-gap: 1em;
  ${TitleText} {
    align-self: center;
  }
`;
const TaskVerticalLine = styled.div`
  display: grid;
  grid-template-rows: auto 0.7em auto;
  align-items: center;
`;
const TaskIndicatorContainer = styled.div`
  height: 0.6em;
  width: 0.65em;
  display: flex;
  justify-content: center;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-items: center;
  border: 1px solid #ebeeff;
  border-radius: 0.6em;
`;

const TaskIndicator = styled.div`
  height: 0.3em;
  width: 0.3em;
  background-color: #d3d9df;
  border-radius: 0.15em;
`;

const VerticalLine = styled.div`
  height: 100%;
  border-right: 1px solid #ebeeff;
  justify-self: center;
`;
